import api from "../../api";
import {promptData} from "../../util/MessageTools";
import {userTypeEnumToString, userTypeStringToEnum} from "../../util/EnumTransition"
import {dateStr2Timestamp, formatDate} from "../../util/TimeTransition"

export default {
  name: "user",
  data() {
    return {
      data: [],
      addUserDialog: false,
      editUserDialog: false,
      updatePasswordDialog: false,
      labelPosition: 'left',
      addUserForm: {
        userName: "",
        password: "",
        trueName: "",
        userPhone: "",
        endPassword: "",
        userTypeEnum: "",
      },
      editUserForm: {
        id: "",
        trueName: "",
        userPhone: "",
        userTypeEnum: "",
      },
      updatePasswordForm: {
        id: "",
        oldPassword: "",
        newPassword: "",
        endNewPassword: "",
      },
      options: [{
        value: 'REFEREE',
        label: '审稿人'
      }, {
        value: 'MANAGER',
        label: '管理员'
      }],
      userRules: {
        userName: [
          {required: true, message: '请输入用户名', trigger: 'submit'},
        ],
        trueName: [
          {required: true, message: '请输入真实姓名', trigger: 'submit'},
        ],
        userPhone: [
          {required: true, message: '请输入手机号码', trigger: 'submit'},
          {min: 11, max: 11, message: '您输入的手机号有误', trigger: 'submit'},
         /* {pattern: /^1[3|4|5|8][0-9]\d{4,8}$/, message: '您输入的手机号有误', trigger: 'submit'},*/
        ],
        userTypeEnum:[
          {required: true, message: '请输入用户类型', trigger: 'submit'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'submit'},
        ],
        endPassword: [
          {required: true, message: '请确认密码', trigger: 'submit'},
        ],
        oldPassword: [
          {required: true, message: '请输入旧密码', trigger: 'submit'},
        ],
        newPassword: [
          {required: true, message: '请输入新密码', trigger: 'submit'},
        ],
        endNewPassword: [
          {required: true, message: '请确认密码', trigger: 'submit'},
        ],
      },
      tableLoading:false
    }
  },
  methods: {

    /**
     * 打开添加用户的弹出框
     */
    openAddUserDialog() {
      this.addUserDialog = true
      this.addUserForm = {}
      //this.addUserForm.userTypeEnum = "REFEREE"
    },

    /**
     * 编辑点击行
     */
    handleEdit(row) {
      this.editUserDialog = true
      this.editUserForm.id = row.id
      this.editUserForm.trueName = row.trueName
      this.editUserForm.userPhone = row.userPhone
      this.editUserForm.userTypeEnum = userTypeStringToEnum(row.userTypeEnum)
    },

    /**
     * 修改用户
     */
    updateUser(formName) {
      let vue = this
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {}
            obj.id = this.editUserForm.id
            obj.trueName = this.editUserForm.trueName
            obj.userPhone = this.editUserForm.userPhone
            obj.userTypeEnum = this.editUserForm.userTypeEnum
            api.user.updateUser(obj).then(function (response) {
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                vue.editUserDialog = false
                for (let i = 0; i < vue.data.length; i++) {
                  if (vue.data[i].id === obj.id) {
                    vue.data[i].trueName = obj.trueName
                    vue.data[i].userPhone = obj.userPhone
                    vue.data[i].userTypeEnum = userTypeEnumToString(vue.editUserForm.userTypeEnum)
                    break
                  }
                }
              }
            })
          }
        }
      );
    },

    /**
     *删除一行
     */
    handleDelete(index, row) {
      let vue = this
      this.$confirm('确定删除当前点击行的用户?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        api.user.deleteUser(row.id).then(function (response) {
          if (response == null) {
            return null
          }
          if (response.data.code === "0") {
            vue.data.splice(index, 1)
          }
        })
      }).catch((err) => {

      })
    },

    /**
     * 点击行的修改密码
     */
    handleUpdatePassword(row) {
      this.updatePasswordDialog = true
      this.updatePasswordForm = {}
      this.updatePasswordForm.id = row.id
    },

    /**
     * 保存修改的密码
     */
    updatePassword(formName) {
      let vue = this
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let oldPassword = vue.updatePasswordForm.oldPassword
            let newPassword = vue.updatePasswordForm.newPassword
            let endNewPassword = vue.updatePasswordForm.endNewPassword
            if (newPassword !== endNewPassword) {
              promptData("两次输入的新密码不一样,请检查!", this)
              return
            }
            api.user.updatePwd(vue.updatePasswordForm.id, oldPassword, newPassword).then(function (response) {
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                vue.updatePasswordDialog = false
              }
            })
          }
        }
      );
    },

    /**
     * 保存用户
     * */
    saveUser(formName) {
      let vue = this
      this.$refs[formName].validate((valid) => {
          if (valid) {
            let obj = {}
            obj.userName = vue.addUserForm.userName
            obj.trueName = vue.addUserForm.trueName
            obj.userPhone = vue.addUserForm.userPhone
            obj.password = vue.addUserForm.password
            obj.userTypeEnum = vue.addUserForm.userTypeEnum
            if (obj.password !== this.addUserForm.endPassword) {
              promptData("两次密码输入的不一样,请检查!", vue)
              return
            }

            obj.createTime = new Date()
            api.user.addUser(obj).then(function (response) {
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                obj.userTypeEnum = userTypeEnumToString(vue.addUserForm.userTypeEnum)
                obj.id = response.data.result
                obj.createTime = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
                vue.data.push(obj)
                vue.addUserDialog = false
              }
            })
          }
        }
      );
    },
  },

  created() {
    let vue = this
    vue.tableLoading = true
    api.user.getUserListOfManagerAndReferee().then(function (response) {
      vue.tableLoading = false
      if (response == null) {
        return null
      }
      if (response.data.code === "0") {
        let result = response.data.result
        for (let i = 0; i < result.length; i++) {
          result[i].createTime = dateStr2Timestamp(result[i].createTime)
          result[i].userTypeEnum = userTypeEnumToString(result[i].userTypeEnum)
        }
        vue.data = result
      }

    }).catch(err=>{
      vue.tableLoading = false
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/Admin/User.js